/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ filename: NonNullable<unknown> }} Image_Inspector_DescriptionInputs */

const en_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Preview and metadata for ${i?.filename}. Press I to toggle the inspector and Escape to close.`)
};

const ar_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`معاينة وبيانات وصفية لـ ${i?.filename}. زر I يبدّل الفاحص، وEscape يغلق النافذة.`)
};

const bn_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.filename} এর প্রিভিউ ও মেটাডেটা। ইন্সপেক্টর দেখাতে বা লুকাতে I চাপুন, বন্ধ করতে Escape চাপুন।`)
};

const de_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vorschau und Metadaten für ${i?.filename}. Mit I blenden Sie den Inspektor ein oder aus, mit Escape schließen Sie das Fenster.`)
};

const es_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vista previa y metadatos de ${i?.filename}. Pulsa I para mostrar u ocultar el inspector y Escape para cerrar.`)
};

const fr_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aperçu et métadonnées de ${i?.filename}. Appuyez sur I pour afficher ou masquer l'inspecteur, et sur Échap pour fermer.`)
};

const pt_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prévia e metadados de ${i?.filename}. Pressione I para mostrar ou ocultar o inspetor e Escape para fechar.`)
};

const zh_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.filename} 的预览和元数据。按 I 显示或隐藏检查器，按 Esc 关闭。`)
};

const tr_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.filename} için önizleme ve meta veriler. Denetçiyi açıp kapatmak için I, kapatmak için Escape tuşuna basın.`)
};

const ru_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Предпросмотр и метаданные ${i?.filename}. Нажмите I, чтобы показать или скрыть инспектор, и Escape, чтобы закрыть.`)
};

const pl_image_inspector_description = /** @type {(inputs: Image_Inspector_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podgląd i metadane pliku ${i?.filename}. Naciśnij I, aby pokazać lub ukryć inspektor, i Escape, aby zamknąć.`)
};

/**
* | output |
* | --- |
* | "Preview and metadata for {filename}. Press I to toggle the inspector and Escape to close." |
*
* @param {Image_Inspector_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_description = /** @type {((inputs: Image_Inspector_DescriptionInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_DescriptionInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_description(inputs)
	if (locale === "bn") return bn_image_inspector_description(inputs)
	if (locale === "de") return de_image_inspector_description(inputs)
	if (locale === "es") return es_image_inspector_description(inputs)
	if (locale === "fr") return fr_image_inspector_description(inputs)
	if (locale === "pt") return pt_image_inspector_description(inputs)
	if (locale === "zh") return zh_image_inspector_description(inputs)
	if (locale === "tr") return tr_image_inspector_description(inputs)
	if (locale === "ru") return ru_image_inspector_description(inputs)
	if (locale === "pl") return pl_image_inspector_description(inputs)
	return en_image_inspector_description(inputs)
});